import React, {useState,useMemo,useEffect} from 'react';
import {RouteComponentProps, Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useReactRouter from 'use-react-router';
import useStyles from './Styles';
//import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
//import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
//import Button from '@mui/material/Button';
import MultiLines from './MultiLines';
import {Inc} from './Inc';
import Ajax from './Ajax';
import NavButton from './NavButton';
import Title from './Title';
import Loading from './Loading';

// interface Props {
// }

interface RCProps extends RouteComponentProps<{id:string}> {
	
}

//let isLoading:boolean = true;
// let infoId = 0;
// let year = 0;

const InfoDetail = ()=> {
    const rcp:RCProps = useReactRouter();
    const classes = useStyles();
    const dt = new Date();
    const nowYear = dt.getFullYear();    
    //const [info,setInfo] = useState(Inc.defaultInfo());
    const [states,setStates] = useState({
        isLoading: true,
        infoId: 0,
        year: 0,
        info: Inc.defaultInfo(),
    })
    const [notFound,setNotFound] = useState(false);

    const load = ()=>{
        const infoId = parseInt(rcp.match.params.id);
        setStates({...states,isLoading:true});
        Ajax.send("info/get",{id:infoId},(res:any)=>{
            //console.log(res);
            //isLoading = false;
            if( res.ok ){
                const sp = res.info.publish_time.split("-");
                //year = parseInt( sp[0] );
                //setInfo(res.info);
                setStates({
                    ...states,
                    infoId: infoId,
                    info:res.info,
                    year:parseInt( sp[0] ),
                    isLoading:false,
                });
            } else {
                setNotFound(true);
            }
        });
    }

    const jump = (e: React.MouseEvent<HTMLElement>) => {
        if( e.currentTarget.dataset.id ){
            rcp.history.push("/info/year/"+e.currentTarget.dataset.id);
            //year = parseInt(e.currentTarget.dataset.id);
            //load();
        }
    }

    const putYears = useMemo(()=>{
        let years:number[] = [];
        for( let y=nowYear ; y>=2008 ; y-- ){
            years.push( y );
        }
        return years.map((y:number,index:number)=>{
            const key = "year"+index;
            return (
                <NavButton key={key} id={String(y)} onClick={jump} label={String(y)+"年"}/>
            )
        })
    },[nowYear,states.year]);

    useEffect( ()=>{
        if( rcp.match.params.id ){
            window.scrollTo(0,0);
            //infoId = parseInt(rcp.match.params.id);
            load();
        } else {
            setNotFound(true);
        }
    },[]);

    if( notFound ){
        return (
            <Redirect to="/"/>
        );
    }

	return (
		<div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                    <Paper className={classes.paper}>
                        <div style={{marginBottom:"0em"}}>
                            <Title text={states.info.title} size={1} icon="store"/>
                            <div style={{paddingBottom:"4em"}}>
                                {states.info.body &&
                                <MultiLines text={states.info.body} autolink={true}/>
                                }
                            </div>
                            <Divider/>
                            <div style={{textAlign:"right",fontSize:"90%"}}>
                                {states.info.publish_time}
                            </div>
                        </div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Paper className={classes.paper}>
                        <Title text="年を指定" size={2}/>
                        <FormControl fullWidth={true}>
                        {putYears}
                        </FormControl>
                    </Paper>
                </Grid>
            </Grid>
			<Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default InfoDetail;
